<template>
  <ContainerBox title="面板资讯">
    <div class="attr-info">
      <div class="base">
        <BorderBg />
        <div class="content">
          <img class="cover" :src="dataSource.cover.value" alt="" />
          <div class="name" :title="dataSource.name.value">
            {{ dataSource.name.value }}
          </div>
          <div class="level">
            {{ dataSource.level.value }}
          </div>
          <div class="base-attr">
            <div>
              {{ dataSource.baseAim.value.value }}
            </div>
            <div>
              {{ dataSource.baseAim.label.value }}
            </div>
          </div>
        </div>
      </div>
      <div class="attr">
        <div class="main-attr">
          <BorderBg />
          <div class="list">
            <div class="item" v-for="key in Object.keys(dataSource.base)" :key="key">
              <div class="label">
                {{ dataSource.base[key].label.value }}
              </div>
              <div class="value">
                {{ dataSource.base[key].value.value }}
              </div>
            </div>
          </div>
        </div>
        <div class="other-attr">
          <BorderBg />
          <div class="list">
            <div class="item" v-for="key in Object.keys(dataSource.detail)" :key="key">
              <div class="label">
                {{ dataSource.detail[key].value.value }}
              </div>
              <div class="value">
                {{ dataSource.detail[key].label.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContainerBox>
</template>

<script>
import ContainerBox from "./containerBox.vue";
import BorderBg from "./borderBg.vue";
export default {
  name: "AttrInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    characterDataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: { ContainerBox, BorderBg },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.attr-info {
  padding-bottom: 15px;
  display: flex;
  gap: 10px;
  .base {
    flex-shrink: 0;
    position: relative;
    width: 118px;
    height: 246px;
    padding: 10px 10px 0;
    .content {
      background: #fff;
      height: calc(100% - 2px);
      .cover {
        width: 100%;
        height: 126px;
        margin-bottom: 10px;
      }
      .name,
      .level {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        line-height: 16px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .base-attr {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 64px;
        height: 44px;
        background: #45474a;
        border-radius: 4px 4px 4px 4px;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 14px;
        margin: 15px auto 0;
      }
    }
  }
  .attr {
    width: 100%;
    .main-attr {
      position: relative;
      width: 100%;
      height: 91px;
      margin-bottom: 16px;
      .list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px 16px;
        padding: 10px;
        .item {
          display: flex;
          align-items: center;
        }
        .label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 59px;
          height: 34px;
          background: #45474a;
          border-radius: 4px 0px 0px 4px;
          font-weight: 500;
          font-size: 12px;
          color: #f2f4f1;
          line-height: 14px;
        }
        .value {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 148px;
          height: 34px;
          background: #ffffff;
          border-radius: 0px 4px 4px 0px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 14px;
        }
      }
    }

    .other-attr {
      position: relative;
      width: 100%;
      height: 139px;
      padding: 10px;
      .list {
        display: flex;
        flex-wrap: wrap;
        gap: 5px 3px;
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 84px;
          height: 57px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #dddee1;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 18px;
        }
      }
    }
  }
}
</style>
